import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // For navigation on button click
import { toast, ToastContainer } from "react-toastify"; // Import react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import the styles for react-toastify

const UrlPage = () => {
  const [websiteUrl, setWebsiteUrl] = useState("");
  const navigate = useNavigate(); // Initialize the navigate function

  // Function to handle form submission when the "Continue" button is clicked
  // const handleSubmit = (e) => {
  //   e.preventDefault();

    

  //   console.log("Website URL:", websiteUrl);

  //   // Show a success toast before navigating
  //   toast.success("Website URL submitted successfully!", {
  //     position: "top-right",
  //     autoClose: 2000, // Closes after 2 seconds
  //     hideProgressBar: false,
  //     closeOnClick: true,
  //     pauseOnHover: true,
  //     draggable: true,
  //   });

  //   // Navigate to the CallsPage after a slight delay to show the toast
  //   setTimeout(() => {
  //     navigate("/calls-page");
  //   }, 1000); // Delay of 1 second
  // };






  const handleSubmit = async (e) => {
    e.preventDefault();

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user || !user.id) {
      toast.error("User not found. Please log in again.");
      navigate("/");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_API}/api/intro-data`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          userId: user.id,
          page: 3,
          data: { websiteUrl },
        }),
      });

      const data = await response.json();
      if (response.ok) {
        toast.success("Website URL submitted successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        console.log("Website URL saved:", data.introData);
        setTimeout(() => navigate("/calls-page"), 1000);
      } else {
        toast.error(data.error || "Failed to save website URL.");
      }
    } catch (error) {
      console.error("Error saving website URL:", error);
      toast.error("An error occurred. Please try again.");
    }
  };




  const handleSkip = () => {
    navigate("/calls-page")
  };



  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-4">
      {/* Main Content */}
      <div className="flex flex-col items-center text-center max-w-lg mx-auto w-full">
        {/* Full-Width Heading */}
        <h1 className="text-4xl font-bold text-gray-900 mb-4 w-screen">
          Now Train Ryngmo on Your Website
        </h1>

        {/* Subheading */}
        <p className="text-gray-600 text-base md:text-lg mb-8 w-screen">
          Provide your website URL so we can train Ryngmo to answer questions about your business.
        </p>

        {/* Input Field */}
        <form onSubmit={handleSubmit} className="w-full">
          <label htmlFor="websiteUrl" className="text-lg font-medium mb-2 w-full">
            Website URL
          </label>
          <input
            type="text"
            id="websiteUrl"
            value={websiteUrl}
            onChange={(e) => setWebsiteUrl(e.target.value)}
            placeholder="Enter your website URL"
            className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:outline-none focus:border-blue-500 mb-4"
          />

          {/* Continue Button */}
          <button
            type="submit"
            className="bg-blue-600 text-white font-medium py-3 px-6 rounded-lg hover:bg-blue-700 transition-colors w-full"
          >
            Continue
          </button>
          <button
              type="button"
              onClick={handleSkip}
              className="bg-gray-200 text-gray-700 font-medium py-2 sm:py-3 px-4 sm:px-6 rounded-lg hover:bg-gray-300 transition-colors w-full text-sm sm:text-base"
            >
              Skip
            </button>
        </form>
      </div>

      {/* Pagination Dots */}
      <div className="mt-10 flex space-x-2 w-full justify-center">
        {/* Dot 1 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        {/* Dot 2 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        {/* Dot 3 (Highlighted) */}
        <div className="w-3 h-3 bg-gray-900 rounded-full"></div>
        {/* Dot 4 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
        {/* Dot 5 */}
        <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
      </div>

      {/* Toast Container */}
      <ToastContainer />
    </div>
  );
};

export default UrlPage;